import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { MessageSquarePlus, X, Loader2, Send } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const CATEGORIES = [
  { id: "bug", label: "🐛 Bug" },
  { id: "suggestion", label: "💡 Suggestion" },
  { id: "question", label: "❓ Question" },
];

export const FeedbackButton = () => {
  const [open, setOpen] = useState(false);
  const [category, setCategory] = useState("bug");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const token = localStorage.getItem("auth_token");
      await axios.post(`${API}/api/feedback`,
        { category, message, page: location.pathname },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} });
      toast.success("Merci ! Feedback transmis au fondateur.");
      setMessage("");
      setOpen(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Envoi impossible. Réessayez.");
    } finally { setSubmitting(false); }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-warn/90 hover:text-warn hover:bg-warn/10 border border-warn/20 bg-warn/5"
        data-testid="nav-feedback-btn"
      >
        <MessageSquarePlus size={16} /> Feedback beta
      </button>
      {open && (
        <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" data-testid="feedback-modal">
          <div className="max-w-md w-full panel p-6 relative">
            <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-white/40 hover:text-white" data-testid="feedback-close-btn" aria-label="Fermer">
              <X size={18} />
            </button>
            <h2 className="font-heading font-bold text-xl mb-1">Feedback beta</h2>
            <p className="text-white/50 text-xs mb-4">Bug, idée, question — votre message arrive directement chez le fondateur.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="flex gap-2">
                {CATEGORIES.map((c) => (
                  <button key={c.id} type="button" onClick={() => setCategory(c.id)}
                          className={`flex-1 text-xs px-2 py-2 rounded-md border transition ${category === c.id ? "border-accent-blue/50 bg-accent-blue/15 text-white" : "border-white/10 bg-white/5 text-white/60 hover:text-white"}`}
                          data-testid={`feedback-cat-${c.id}`}>
                    {c.label}
                  </button>
                ))}
              </div>
              <textarea required minLength={5} maxLength={2000} rows={5}
                        value={message} onChange={(e) => setMessage(e.target.value)}
                        className="field w-full resize-none"
                        placeholder={category === "bug" ? "Décrivez le bug : que faisiez-vous, qu'attendiez-vous, que s'est-il passé ?" : "Votre message..."}
                        data-testid="feedback-message-input" />
              <button type="submit" disabled={submitting || message.trim().length < 5}
                      className="btn btn-primary w-full justify-center py-2.5 disabled:opacity-40"
                      data-testid="feedback-submit-btn">
                {submitting ? <Loader2 size={15} className="animate-spin" /> : <><Send size={14} /> Envoyer</>}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
